export const hasLocalStorage = () => {
  let hasLocalStorage = false
  try {
    const testKey = '__test__'
    localStorage.setItem(testKey, '1')
    localStorage.removeItem(testKey)
    hasLocalStorage = true
  } catch (e) {
    // Safariなどで SecurityError が発生するケースに対応
    hasLocalStorage = false
  }
  return hasLocalStorage
}
